/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description production config
 */

const hostname = location.hostname;
const apexDomain = hostname.split('.').slice(-2).join('.');
const tenant = hostname.split('.')[0];
const serverHost = `${tenant}.api.${apexDomain}`;

if (!tenant) {
	throw new Error('Tenant is not set');
}

const config: JeevesAppConfig = {
	environment: ENVIRONMENT,
	isLocalhost: false,
	isIntegration: false,
	isProduction: true,
	basePath: '/',
	hostname,
	origin: `https://${location.hostname}`,
	tld: 'app',
	tenant,
	client: {
		url: `https://${serverHost}`,
	},
	chatAgent: {
		url: 'https://jeeves-agent.314ecorp.com',
	},
	keycloak: {
		url: window.AUTH_URL ?? `https://${hostname}/auth`,
		realm: tenant,
		clientId: sessionStorage.getItem('AUTH_CLIENT') ?? 'jeeves',
	},
	novu: {
		backendUrl: `https://${serverHost}/alerting`,
		socketUrl: `wss://${serverHost}`,
	},
	posthog: {
		apiKey: 'phc_2QK0iP1YfOKWlvgJx3TFW8LCYs4AzW8CA83iLdHhXTz',
		options: {
			api_host: `https://${tenant}.okjeeves.app/_ph`,
			opt_out_capturing_by_default: false,
			capture_pageview: false,
			capture_pageleave: false,
		},
	},
	faro: {
		url: `https://${serverHost}/logcollect`,
		apiKey: 'reC!6G!K',
	},
	adobeClientId: '557e8b57d10640359c6b685c018c3148',
};

export default config;
